/** 图片编辑模式。 */
export type ImageEditMode = 'fill' | 'fit' | 'crop';

/** 适应模式的背景色。 */
export type ImageBackgroundColor = 'black' | 'white';

/**
 * 将适应模式背景选项转换为固定 CSS 颜色。
 * @param backgroundColor - 用户选择的背景色
 * @returns 纯黑或纯白 CSS 颜色
 */
export function getImageBackgroundColor(backgroundColor: ImageBackgroundColor): 'black' | 'white' {
    return backgroundColor;
}

/** 图片输出尺寸。 */
export interface ImageOutputDimensions {
    /** 输出宽度，单位 px。 */
    width: number;
    /** 输出高度，单位 px。 */
    height: number;
}

/**
 * 根据原图尺寸和目标比例计算不放大原图的输出尺寸。
 * @param sourceWidth - 原图宽度，单位 px
 * @param sourceHeight - 原图高度，单位 px
 * @param aspectRatio - 目标宽高比
 * @param maxDimension - 输出最长边上限，单位 px
 * @returns 输出尺寸；输入非法时返回 null
 */
export function getImageOutputDimensions(
    sourceWidth: number,
    sourceHeight: number,
    aspectRatio: number,
    maxDimension = 1280,
): ImageOutputDimensions | null {
    if (
        !Number.isFinite(sourceWidth) ||
        !Number.isFinite(sourceHeight) ||
        !Number.isFinite(aspectRatio) ||
        !Number.isFinite(maxDimension) ||
        sourceWidth <= 0 ||
        sourceHeight <= 0 ||
        aspectRatio <= 0 ||
        maxDimension <= 0
    ) {
        return null;
    }

    const widthLimit = Math.min(sourceWidth, maxDimension);
    const heightLimit = Math.min(sourceHeight, maxDimension / aspectRatio);
    const height = Math.min(heightLimit, widthLimit / aspectRatio);
    const width = height * aspectRatio;

    return {
        width: Math.max(1, Math.round(width)),
        height: Math.max(1, Math.round(height)),
    };
}
